export enum StatusTagThemes {
    DEFAULT = 'default',
    DARK = 'dark'
}